<template>
  <div class="index-page container">
    <n-card>
      <n-divide class="table-tools">
        <div></div>
        <n-button @click="exportReport">Экспорт</n-button>
      </n-divide>
      
      <n-table id="tablePays" :data="data" :columns="columns" :loading="$var('load')">
        <template #createdAt="{item}">
          {{ $app.date.format(item.createdAt, 'datetime') }}
        </template>
        <template #account="{item}">
          {{ item.account.fullName }} ({{ item.account.email }}) ({{ item.account.phone }})
        </template>
        <template #course.title="{item}">
          <div v-if="item.course">
            {{ item.course.title }}
          </div>
          <div v-else>Подписка</div>
        </template>
        <template #tools="{item}">
          <n-button icon="eye" flat round @click="$router.push({name: 'types.edit', params: { id: item.id, }})" />
        </template>
      </n-table>
    </n-card>
    <iframe id="txtArea1" style="display:none"></iframe>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data: () => ({
    data: [],
    columns: [
      { name: 'account', title: 'Покупатель', },
      { name: 'course.title', title: 'Курс', },
      { name: 'price', title: 'Цена', },
      { name: 'course.partner.title', title: 'Провайдер', },
      { name: 'createdAt', title: 'Дата покупки', },
    ],
  }),
  mounted() {
    this.loadModels()
  },
  methods: {
    loadModels() {
      this.$var('load', true)
      $api.app.pays.get().then((response) => {
        this.data = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
    exportReport() {
      let content = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">'
      content = content + '<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>'
  
      content = content + '<meta charset="UTF-8" /><x:Name>Лист1</x:Name>'
  
      content = content + '<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>'
      content = content + '</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>'
  
      content = content + '<table border=\'1px\'>'
  
      const rows = document.getElementById('tablePays').querySelectorAll('div.row')
      content += $n.reduce(rows, (result, item) => {
        result += '<tr>'
        const cols = item.querySelectorAll('div.cell')
        cols.forEach((col) => {
          result += '<td>' + col.innerHTML + '</td>'
        })
        result += '</tr>'
        return result
      }, '')
      
      content = content + '</table></body></html>'
  
      const ua = window.navigator.userAgent
      const msie = ua.indexOf('MSIE ')
  
      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        if (window.navigator.msSaveBlob) {
          const blob = new Blob([ content, ], {
            type: 'application/csv;charset=utf-8;',
          })
          navigator.msSaveBlob(blob, 'Отчет.xls')
        }
      } else {
        const link = document.createElement('a')
        link.download = 'export.xls'
        link.href = 'data:application/vnd.ms-excel, ' + encodeURIComponent(content)
        link.click()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  .index-page {
  
    --n-image-width: 150px;
    --n-image-height: 150px;
  }
</style>
